import { useMemo } from "react";

/**
 * Укороченный вид ссылки в пузыре (полный URL в title и в href).
 */
export function shortenUrlForDisplay(url, maxLen = 46) {
  const u = String(url);
  if (u.length <= maxLen) return u;
  const head = 26;
  const tail = 12;
  return `${u.slice(0, head)}…${u.slice(-tail)}`;
}

/** Убрать пунктуацию в конце совпадения (не более пары символов). */
function hrefFromRaw(raw) {
  let u = raw;
  for (let i = 0; i < 3 && u.length > 10; i++) {
    if (/[.,;:!?'")\]]$/u.test(u)) u = u.slice(0, -1);
    else break;
  }
  return u || raw;
}

/**
 * Разбить текст на фрагменты текста и http(s)-ссылок.
 */
export function splitTextWithUrls(text) {
  const s = String(text ?? "");
  const re = /(https?:\/\/[^\s]+)/gi;
  const parts = [];
  let last = 0;
  let m;
  while ((m = re.exec(s)) !== null) {
    if (m.index > last) {
      parts.push({ type: "text", text: s.slice(last, m.index) });
    }
    const raw = m[0];
    const url = hrefFromRaw(raw);
    parts.push({
      type: "url",
      url,
      display: shortenUrlForDisplay(url),
    });
    last = m.index + raw.length;
  }
  if (last < s.length) {
    parts.push({ type: "text", text: s.slice(last) });
  }
  if (parts.length === 0) {
    parts.push({ type: "text", text: s });
  }
  return parts;
}

/**
 * Отображение текста сообщения: ссылки короткие, href/title — полные (копирование из меню — полный текст).
 */
export function MsgTextWithLinks({ text, className }) {
  const parts = useMemo(() => splitTextWithUrls(text), [text]);
  return (
    <span className={className}>
      {parts.map((p, i) =>
        p.type === "url" ? (
          <a
            key={`u-${i}`}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            className="msgTextLink"
            title={p.url}
            onClick={(e) => e.stopPropagation()}
          >
            {p.display}
          </a>
        ) : (
          <span key={`t-${i}`}>{p.text}</span>
        )
      )}
    </span>
  );
}
